export const MENU_LIST = 'menu/list'
